import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import ComicNew from "../features/admin/routes/ComicNew";
import ComicUpdate from "../features/admin/routes/ComicUpdate";
import ComicsList from "../features/admin/routes/ComicsList";
import ReadingOrderComics from "../features/admin/routes/ReadingOrderComics";
import ReadingOrderEdit from "../features/admin/routes/ReadingOrderEdit";
import ReadingOrderList from "../features/admin/routes/ReadingOrderList";
import ReadingOrderNew from "../features/admin/routes/ReadingOrderNew";
import ReadingOrderPublish from "../features/admin/routes/ReadingOrderPublish";
import Login from "../features/auth/routes/Login";
import Reset from "../features/auth/routes/Reset";
import Settings from "../features/auth/routes/Settings";
import Signup from "../features/auth/routes/Signup";
import Billing from "../features/billing/routes/Billing";
import Subscribe from "../features/billing/routes/Subscribe";
import Browse from "../features/browse/routes/Browse";
import BrowseOrderPreview from "../features/browse/routes/BrowseOrderPreview";
import BrowseOrders from "../features/browse/routes/BrowseOrders";
import DiscoverOrders from "../features/browse/routes/DiscoverOrders";
import CinematicUniverses from "../features/releases/routes/CinematicUniverses";
import ScreenReleaseDetail from "../features/releases/routes/ScreenReleaseDetail";
import ReadingOrderCorrection from "../features/browse/routes/ReadingOrderCorrection";
import Requests from "../features/browse/routes/Requests";
import ComicDetail from "../features/comics/routes/ComicDetail";
import Community from "../features/community/routes/Community";
import BookClub from "../features/community/routes/BookClub";
import BookClubAdminEdit from "../features/community/routes/BookClubAdminEdit";
import PublicBookClub from "../features/community/routes/PublicBookClub";
import Cookies from "../features/homepage/routes/Cookies";
import Eula from "../features/homepage/routes/Eula";
import Homepage from "../features/homepage/routes/Homepage";
import NotFound from "../features/homepage/routes/NotFound";
import Privacy from "../features/homepage/routes/Privacy";
import Terms from "../features/homepage/routes/Terms";
import MyOrders from "../features/library/routes/MyOrders";
import MyOrdersComics from "../features/library/routes/MyOrdersComics";
import MyOrdersEdit from "../features/library/routes/MyOrdersEdit";
import MyOrdersNew from "../features/library/routes/MyOrdersNew";
import MyOrdersView from "../features/library/routes/MyOrdersView";
import News from "../features/news/routes/News";
import PartnerReadingOrderComicsForm from "../features/partnership/routes/PartnerReadingOrderComicsForm";
import PartnerReadingOrderList from "../features/partnership/routes/PartnerReadingOrderList";
import PartnerReadingOrderNew from "../features/partnership/routes/PartnerReadingOrderNew";
import PartnerReadingOrderUpdate from "../features/partnership/routes/PartnerReadingOrderUpdate";
import Account from "../features/profile/routes/Account";
import Profile from "../features/profile/routes/Profile";
import PublicProfile from "../features/profile/routes/PublicProfile";
import CompletedReadingOrders from "../features/reading/routes/CompletedReadingOrders";
import Reading from "../features/reading/routes/Reading";
import ReadingOrder from "../features/reading/routes/ReadingOrder";
import usePageTracking from "../shared/hooks/usePageTracking";
import Navigation from "./Navigation";
import RequireAdminRole from "./RequireAdminRole";
import RequireAuth from "./RequireAuth";
import RequireNoAuth from "./RequireNoAuth";
import RequirePartnerRole from "./RequirePartnerRole";
import UpgradeModal from "./UpgradeModal";
const AuthLayout = () => (
  <div>
    <Outlet />
  </div>
);

const AppLayout = () => (
  <div>
    <Navigation />
    <Outlet />
    <UpgradeModal />
  </div>
);

export default function RedwingRoutes() {
  usePageTracking();
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route
          path="news"
          element={
            <RequireAuth>
              <News />
            </RequireAuth>
          }
        />
        <Route
          path="reading"
          element={
            <RequireAuth>
              <Reading />
            </RequireAuth>
          }
        />
        <Route
          path="reading/completed"
          element={
            <RequireAuth>
              <CompletedReadingOrders />
            </RequireAuth>
          }
        />
        <Route
          path="reading/:readingId"
          element={
            <RequireAuth>
              <ReadingOrder />
            </RequireAuth>
          }
        />
        <Route
          path="browse"
          element={
            <RequireAuth>
              <Browse />
            </RequireAuth>
          }
        />
        <Route path="community" element={<Community />} />
        <Route path="community/book-club" element={<BookClub />} />
        <Route
          path="bookclub/admin"
          element={
            <RequireAdminRole>
              <Navigate
                to="/reading-orders/all"
                replace
                state={{ adminTab: 3 }}
              />
            </RequireAdminRole>
          }
        />
        <Route
          path="bookclub/admin/book-clubs/new"
          element={
            <RequireAdminRole>
              <BookClubAdminEdit />
            </RequireAdminRole>
          }
        />
        <Route
          path="bookclub/admin/book-clubs/:clubId/edit"
          element={
            <RequireAdminRole>
              <BookClubAdminEdit />
            </RequireAdminRole>
          }
        />
        <Route
          path="browse/requests"
          element={
            <RequireAuth>
              <Requests />
            </RequireAuth>
          }
        />
        <Route
          path="browse/discover/:section"
          element={
            <RequireAuth>
              <DiscoverOrders />
            </RequireAuth>
          }
        />
        <Route
          path="browse/cinematic-universes/list"
          element={
            <RequireAuth>
              <CinematicUniverses />
            </RequireAuth>
          }
        />
        <Route
          path="browse/releases/:releaseId"
          element={
            <RequireAuth>
              <ScreenReleaseDetail />
            </RequireAuth>
          }
        />
        <Route
          path="browse/:category/list"
          element={
            <RequireAuth>
              <BrowseOrders />
            </RequireAuth>
          }
        />
        <Route
          path="browse/:readingOrderId/preview"
          element={
            <RequireAuth>
              <BrowseOrderPreview />
            </RequireAuth>
          }
        />
        <Route
          path="comics/:comicId/view"
          element={
            <RequireAuth>
              <ComicDetail />
            </RequireAuth>
          }
        />
        <Route
          path="profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="profile/:userHandle"
          element={
            <RequireAuth>
              <PublicProfile />
            </RequireAuth>
          }
        />
        {/* Settings */}
        <Route
          path="go-premium"
          element={
            <RequireAuth>
              <Subscribe />
            </RequireAuth>
          }
        />
        <Route
          path="billing"
          element={
            <RequireAuth>
              <Billing />
            </RequireAuth>
          }
        />
        <Route
          path="account"
          element={
            <RequireAuth>
              <Account />
            </RequireAuth>
          }
        />
        <Route
          path="settings"
          element={
            <RequireAuth>
              <Settings />
            </RequireAuth>
          }
        />

        {/* My reading orders */}
        <Route
          path="my-orders/"
          element={
            <RequireAuth>
              <MyOrders />
            </RequireAuth>
          }
        />
        <Route
          path="my-orders/:readingOrderId/edit"
          element={
            <RequireAuth premiumOnly>
              <MyOrdersEdit />
            </RequireAuth>
          }
        />
        <Route
          path="my-orders/:readingOrderId/publish"
          element={
            <RequireAuth premiumOnly>
              <MyOrdersEdit />
            </RequireAuth>
          }
        />
        <Route
          path="my-orders/:id/edit-order"
          element={
            <RequireAuth premiumOnly>
              <MyOrdersComics />
            </RequireAuth>
          }
        />
        <Route
          path="my-orders/:readingOrderId/"
          element={
            <RequireAuth premiumOnly>
              <MyOrdersView />
            </RequireAuth>
          }
        />

        <Route
          path="my-orders/new"
          element={
            <RequireAuth premiumOnly>
              <MyOrdersNew />
            </RequireAuth>
          }
        />

        {/* Partnership */}
        <Route path="partnership/">
          <Route
            path="reading-orders/new"
            element={
              <RequirePartnerRole>
                <PartnerReadingOrderNew />
              </RequirePartnerRole>
            }
          />
          <Route
            path="reading-orders/:id/edit"
            element={
              <RequirePartnerRole>
                <PartnerReadingOrderUpdate />
              </RequirePartnerRole>
            }
          />
          <Route
            path="reading-orders/:id/comics"
            element={
              <RequirePartnerRole>
                <PartnerReadingOrderComicsForm />
              </RequirePartnerRole>
            }
          />
          <Route
            path="reading-orders/all"
            element={
              <RequirePartnerRole>
                <PartnerReadingOrderList />
              </RequirePartnerRole>
            }
          />
        </Route>

        <Route
          path="reading-orders/:readingOrderId/suggest-correction"
          element={
            <RequireAuth>
              <ReadingOrderCorrection />
            </RequireAuth>
          }
        />

        {/* ADMIN  */}

        {/* Admin/reading-orders */}
        <Route
          path="reading-orders/new"
          element={
            <RequireAdminRole>
              <ReadingOrderNew />
            </RequireAdminRole>
          }
        />
        <Route
          path="reading-orders/:id/edit"
          element={
            <RequireAdminRole>
              <ReadingOrderEdit />
            </RequireAdminRole>
          }
        />
        <Route
          path="reading-orders/:id/publish"
          element={
            <RequireAdminRole>
              <ReadingOrderPublish />
            </RequireAdminRole>
          }
        />
        <Route
          path="reading-orders/:id/comics"
          element={
            <RequireAdminRole>
              <ReadingOrderComics />
            </RequireAdminRole>
          }
        />
        <Route
          path="reading-orders/all"
          element={
            <RequireAdminRole>
              <ReadingOrderList />
            </RequireAdminRole>
          }
        />
        {/* Admin/comics */}
        <Route
          path="comics/all"
          element={
            <RequireAdminRole>
              <ComicsList />
            </RequireAdminRole>
          }
        />
        <Route
          path="comics/new"
          element={
            <RequireAdminRole>
              <ComicNew />
            </RequireAdminRole>
          }
        />
        <Route
          path="comics/:id/edit"
          element={
            <RequireAdminRole>
              <ComicUpdate />
            </RequireAdminRole>
          }
        />
      </Route>
      <Route element={<AuthLayout />}>
        <Route
          index
          element={
            <RequireNoAuth>
              <Homepage />
            </RequireNoAuth>
          }
        />
        <Route
          path="/terms"
          element={
            <RequireNoAuth>
              <Terms />
            </RequireNoAuth>
          }
        />
        <Route
          path="/privacy"
          element={
            <RequireNoAuth>
              <Privacy />
            </RequireNoAuth>
          }
        />
        <Route
          path="/eula"
          element={
            <RequireNoAuth>
              <Eula />
            </RequireNoAuth>
          }
        />
        <Route
          path="/cookie"
          element={
            <RequireNoAuth>
              <Cookies />
            </RequireNoAuth>
          }
        />
        <Route
          path="/login"
          element={
            <RequireNoAuth>
              <Login />
            </RequireNoAuth>
          }
        />
        <Route
          path="/signup"
          element={
            <RequireNoAuth>
              <Signup />
            </RequireNoAuth>
          }
        />
        <Route path="/book-club" element={<PublicBookClub />} />
        <Route path="/reset" element={<Reset />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
